"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fieldset = void 0;
exports.getCustomTheme = getCustomTheme;
exports.placeholder = placeholder;
exports.textField = exports.textAreaRoot = void 0;
exports.textFieldBaseStyles = textFieldBaseStyles;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledIs = _interopRequireDefault(require("styled-is"));
var _spacing = _interopRequireDefault(require("../../styles/spacing"));
var _variables = require("./variables");
var _fonts = require("../../styles/fonts");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _mixins = require("../../styles/mixins");
var _color = require("../../utils/color.utils");
var _templateObject;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/* Wrapper for standard input and textarea */
var Fieldset = exports.Fieldset = _styledComponents["default"].div.withConfig({
  displayName: "HBTextFieldstyles__Fieldset",
  componentId: "sc-ig2ckc-0"
})(["position:relative;margin-bottom:", ";"], _spacing["default"][20]);

/* Placeholder util */
function placeholder(_fontSize, color) {
  return (0, _styledComponents.css)(["&::placeholder{color:", ";transition:color ", ";opacity:0.6;}"], color, _variables.inputEase);
}
function getCustomThemeHoverBorderColor(borderColor, background, errorColor, error) {
  if (error) {
    return "border-color: ".concat(errorColor, ";");
  }

  // For cases where there's no border + an invisible background (which is explicitly defined)
  if (!borderColor && background === _colors["default"].transparent) {
    return null;
  }
  if (!borderColor || borderColor === _colors["default"].transparent) {
    return "border-color: ".concat((0, _color.darken)(background, 0.1));
  }
  return "border-color: ".concat((0, _color.darken)(borderColor, 0.1), ";");
}
function getCustomThemeFocusBorderColor(borderColor, background, errorColor, error) {
  if (error) {
    return "border-color: ".concat(errorColor, ";");
  }

  // fill only
  if (!borderColor || borderColor === _colors["default"].transparent) {
    return "border-color: ".concat(_colors["default"].transparent);
  }

  // border only
  if (background && background !== _colors["default"].transparent) {
    return "border-color: ".concat((0, _color.darken)(borderColor, 0.4), ";");
  }

  // border and fill
  return "border-color: ".concat((0, _color.darken)(borderColor, 0.1), ";");
}
function getCustomThemeFocusBackgroundColor(background) {
  if (background === _colors["default"].transparent) {
    return null;
  }
  return "background: ".concat(background ? (0, _color.darken)(background, 0.1) : _colors["default"].white, ";");
}

/* Theme styles */
function getCustomTheme(customTheme, error, size) {
  var _customFont$fontFamil;
  var _customTheme$fontFami = customTheme.fontFamily,
    fontFamily = _customTheme$fontFami === void 0 ? 'ProximaNova' : _customTheme$fontFami,
    _customTheme$fontColo = customTheme.fontColor,
    fontColor = _customTheme$fontColo === void 0 ? _colors["default"].neutral900 : _customTheme$fontColo,
    background = customTheme.background,
    borderColor = customTheme.borderColor,
    _customTheme$borderRa = customTheme.borderRadius,
    borderRadius = _customTheme$borderRa === void 0 ? null : _customTheme$borderRa,
    _customTheme$padding = customTheme.padding,
    padding = _customTheme$padding === void 0 ? null : _customTheme$padding,
    fontWeight = customTheme.fontWeight,
    _customTheme$errorCol = customTheme.errorColor,
    errorColor = _customTheme$errorCol === void 0 ? _colors["default"].red50 : _customTheme$errorCol;
  return (0, _styledComponents.css)(["color:", ";font-family:", ";background:", ";font-weight:", ";border:1px solid ", ";", " ", " font-size:", ";", " &:hover{", "}&:focus,&:focus-within{", " ", "}"], fontColor, ((_customFont$fontFamil = _fonts.customFont[fontFamily]) === null || _customFont$fontFamil === void 0 ? void 0 : _customFont$fontFamil.font_family) || "".concat(fontFamily, ", 'ProximaNova'"), background || _colors["default"].white, fontWeight, borderColor || _colors["default"].transparent, borderRadius && "border-radius: ".concat(borderRadius, ";"), padding && "padding: ".concat(padding, ";"), _variables.fontSize[size].fontSize, (0, _styledIs["default"])('error')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n            border-color: ", ";\n        "])), errorColor), getCustomThemeHoverBorderColor(borderColor, background, errorColor, error), getCustomThemeFocusBackgroundColor(background), getCustomThemeFocusBorderColor(borderColor, background, errorColor, error));
}

// These styles are defined here:
// zpl://screen?pid=5ef37a91707c097fa62c4c3b&sid=5f0721658adfb0784bc8d376
function getThemeStyles(_ref) {
  var size = _ref.size,
    customTheme = _ref.customTheme,
    error = _ref.error,
    showBorder = _ref.$showBorderWhenRequired;
  if (customTheme) {
    return (0, _styledComponents.css)(["", " ", ";"], getCustomTheme(customTheme, error, size), placeholder(_variables.fontSize[size], customTheme.fontColor));
  }
  return (0, _styledComponents.css)(["color:", ";&::placeholder{color:", ";}background:", ";border:", ";&:focus,&:focus-within{background:", ";border-color:", ";}", " &:disabled,&:disabled:hover{cursor:not-allowed;background:", ";color:", ";border-color:", ";}"], _colors["default"].textPrimary, _colors["default"].textTertiary, _colors["default"].neutral100, showBorder ? "1px solid ".concat(_colors["default"].neutral500) : '1px solid transparent', _colors["default"].neutral200, showBorder ? _colors["default"].neutral500 : _colors["default"].transparent, error && (0, _styledComponents.css)(["&,&:hover,&:focus,&:hover{border-color:", ";}"], _colors["default"].red50), _colors["default"].neutral100, _colors["default"].textTertiary, _colors["default"].transparent);
}

/* Common styles */
var foundationResets = "\n    height: unset;\n    background: unset;\n\n    &:focus {\n        background: unset;\n        border-color: transparent;\n        outline: unset;\n    }\n";
var textField = exports.textField = (0, _styledComponents.css)(["", " box-sizing:border-box;border:none;display:block;margin:0;width:100%;outline:none;border-radius:4px;"], _mixins.proximaNova);
function textFieldBaseStyles(props) {
  return (0, _styledComponents.css)(["", " ", " box-sizing:border-box;border:none;display:block;margin:0;width:", ";outline:none;", ";transition:background ", ",border-color ", ";", " padding-right:20px;"], foundationResets, textField, props.width || '100%', _variables.fontSize[props.size], _variables.inputEase, _variables.inputEase, getThemeStyles(props));
}
var textAreaRoot = exports.textAreaRoot = (0, _styledComponents.css)(["resize:none;overflow-y:scroll;&::-webkit-scrollbar{", ";}&::-webkit-scrollbar-thumb{", ";}"], _mixins.scrollVertical, _mixins.scrollThumb);
//# sourceMappingURL=HBTextField.styles.js.map